<div class="view-page-title">
    <h4>{{'administration_accredCal_label' | translate }}</h4>
</div>
<div class="mt-2">
    <scheduler [(accreditationInfo)]="accreditationInfo"></scheduler>
</div>